const Description = ({ text }) => {
  return (
    <>
      <p className="text-muted mb-4">{text}</p>
      <hr />
    </>
  );
};

export default Description; 